const affiliationCountries = [
    // Countries have uppercase codes by opposition to language codes
    {
        code: 'BE',
        translations: {
            'fr': 'Belgique',
            'en': 'Belgium',
        }
    },
    {
        code: 'CH',
        translations: {
            'fr': 'Suisse',
            'en': 'Switzerland',
        }
    },
    {
        code: 'DE',
        translations: {
            'fr': 'Allemagne',
            'en': 'Germany',
        }
    },
    {
        code: 'FR',
        translations: {
            'fr': 'France',
            'en': 'France',
        }
    },
]

export function affiliationCountriesSortedBy( sortLanguage ) {
    const sortMethod = ( a, b ) => {
        return a.translations[ sortLanguage ].localeCompare( b.translations[ sortLanguage ], sortLanguage );
    }
    return affiliationCountries.sort( sortMethod );
}
